<template>
	<div v-show="isDatePicker">
		<div class="overlay" @click="showPicker(false)"></div>
		<date-picker class="date_picker" :disabled="day" :inline="true" language="ru" @selected="update"></date-picker>
	</div>
</template>

<script>
	import DatePicker from 'vuejs-datepicker'
	import moment from 'moment'

	export default {
		name: "DatePickerModal",
		components: {DatePicker},
		mounted() {
			this.$event.connect('openDatePicker', () => this.showPicker(true));
			this.$event.connect('closeDatePicker', () => this.showPicker(false));
		},
		beforeDestroy() {
			this.$event.disconnect(['openDatePicker', 'closeDatePicker'])
		},
		data() {
			return {
				isDatePicker: false,
				day: {}
			}
		},
		methods: {
			showPicker(bool) {
				this.isDatePicker = bool
				this.day = {}
			},
			openModal(record) {
				record.isSpecial = true;
				this.$event.send('openTimeModal', record);
				this.showPicker(false)
			},
			update(day) {
				this.openModal({pickerDate: moment(day).format('YYYY-MM-DD')})
				this.showPicker(false)
			}
		}
	}
</script>

<style scoped>
	.date_picker {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 510;
	}
</style>



// WEBPACK FOOTER //
// DatePickerModal.vue?30e3b1b9